import {BASE_PATH_API, TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV, CompanyCode} from 'constants/general'
import axios from 'axios'
import { decodeStorage } from 'functions/storageBase64'

export async function downloadStatement({cardending, period}){
    let apiURL
    const no_internet = decodeStorage('sears_numero_internet')

    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/cards/${cardending}/download-statement?NoInternet=${no_internet}`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/cards/${cardending}/download-statement?NoInternet=${no_internet}`
    }
    const access_token = decodeStorage('access_token')

    const raws = {
        "CompanyCode": CompanyCode,
        "Year": period.anio,
        "Month": period.mes
    }

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        data: raws,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}
